import { useEffect } from 'react';
import Lenis from 'lenis';

import { LanguageProvider } from './context/LanguageContext';
import { PasswordGate } from './components/PasswordGate';
import { Navigation } from './components/Navigation';
import { Hero } from './components/Hero';
import { Schedule } from './components/Schedule';
import { Venue } from './components/Venue';
import { Accommodations } from './components/Accommodations';
import { WhereToVisit } from './components/WhereToVisit';
import { WhereToEat } from './components/WhereToEat';
import { FAQ } from './components/FAQ';
import { Gallery } from './components/Gallery';
import { Registry } from './components/Registry';
import { RSVPForm } from './components/RSVPForm';
import { Footer } from './components/Footer';

function App() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      orientation: 'vertical',
      smoothWheel: true,
    });

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);
    return () => lenis.destroy();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- one-time mount effect; lenis/raf are local to this run and must not retrigger
  }, []);

  return (
    <LanguageProvider>
      <PasswordGate>
        <div className="App" data-testid="wedding-app">
          <Navigation />
          <main>
            <div id="home"><Hero /></div>
            <div id="schedule"><Schedule /></div>
            <div id="venue"><Venue /></div>
            <div id="accommodations"><Accommodations /></div>
            <div id="explore"><WhereToVisit /></div>
            <div id="eat"><WhereToEat /></div>
            <div id="faq"><FAQ /></div>
            <div id="gallery"><Gallery /></div>
            <div id="registry"><Registry /></div>
            <div id="rsvp"><RSVPForm /></div>
          </main>
          <Footer />
        </div>
      </PasswordGate>
    </LanguageProvider>
  );
}

export default App;
